import { isSuperAdminUi } from '@/lib/super-admin-ui';

function readPublicEnvTrue(key: string): boolean {
  if (typeof process === 'undefined') return false;
  const v = process.env[key];
  return v === 'true' || v === '1';
}

/**
 * Кассовый контур в WebAdmin — только платформенный super.
 * NEXT_PUBLIC_CASH_METRICS_UI=true — override для smoke.
 */
export function isCashMetricsUiVisible(email?: string | null): boolean {
  if (readPublicEnvTrue('NEXT_PUBLIC_CASH_METRICS_UI')) return true;
  return isSuperAdminUi(email);
}
